import usePage from "@/layout/hooks/usePage";
import { PageType } from "@/types/page";

type LabelKey = 'customer' | 'customerModel' | 'price' | 'detail'

const useSaleItemLabel = () => {
  const { pageType } = usePage();

  const getLabelShow = (labelKey: LabelKey) => {
    const maps: {
      [key in LabelKey]: boolean
    } = {
      customer: pageType ? ![PageType.SALE, PageType.FINANCE].includes(pageType) : true,
      customerModel: pageType ? ![PageType.SALE, PageType.FINANCE].includes(pageType) : true,
      price: pageType ? ![PageType.SALE, PageType.FINANCE].includes(pageType) : true,
      detail: pageType ? ![PageType.SALE, PageType.FINANCE].includes(pageType) : true,
    }

    return maps[labelKey]
  }

  return { getLabelShow };
};

export default useSaleItemLabel;
